export class ForgeProjectFeatureArtifact {
    constructor(model) {
        this.id = model.id;
        this.key = model.key;
        this.fileId = model.fileId;
        this.filePath = model.filePath;
        this.iterationId = model.iterationId;
        this.url = model.url;
        this.iterationId = model.iterationId;
        this.createdAt = new Date(model.createdAt);
        this.updatedAt = new Date(model.updatedAt);
    }
    toRemote() {
        return {
            ...this,
            createdAt: this.createdAt.toISOString(),
            updatedAt: this.updatedAt.toISOString(),
        };
    }
}
